const NOTES = ['G2', 'B2', 'D3', 'G3', 'B3', 'G4'];
const SAMPLE_BASE = 'https://nbrosowsky.github.io/tonejs-instruments/samples/guitar-acoustic/';

let _audioCtx = null;
let _guitarBuffers = [];
let _loadingPromise = null;

function getAudioCtx() {
	if (!_audioCtx) _audioCtx = new (window.AudioContext || window.webkitAudioContext)();
	return _audioCtx;
}

export function loadSamples() {
	if (_guitarBuffers.length === 6) return Promise.resolve();
	if (_loadingPromise) return _loadingPromise;

	const ctx = getAudioCtx();
	_loadingPromise = Promise.all(NOTES.map(note =>
		fetch(`${SAMPLE_BASE}${note}.wav`)
			.then(r => r.arrayBuffer())
			.then(buf => ctx.decodeAudioData(buf))
	)).then(buffers => {
		buffers.forEach((b, i) => { _guitarBuffers[i] = b; });
	}).catch(e => console.error('Could not load guitar samples', e));

	return _loadingPromise;
}

export function playMetronome(isFirstBeat) {
	const ctx = getAudioCtx();
	if (ctx.state === 'suspended') ctx.resume();
	const osc = ctx.createOscillator();
	const gain = ctx.createGain();
	osc.connect(gain);
	gain.connect(ctx.destination);
	osc.type = 'triangle';
	osc.frequency.setValueAtTime(isFirstBeat ? 1000 : 800, ctx.currentTime);
	gain.gain.setValueAtTime(0, ctx.currentTime);
	gain.gain.linearRampToValueAtTime(0.5, ctx.currentTime + 0.002);
	gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.04);
	osc.start(ctx.currentTime);
	osc.stop(ctx.currentTime + 0.05);
}

export function playGuitarStrum(direction) {
	const ctx = getAudioCtx();
	if (ctx.state === 'suspended') ctx.resume();
	if (_guitarBuffers.length < 6) return;

	const isMute = direction === 'X';
	const isBass = direction === 'B';
	const isDown = direction === 'D' || isMute || isBass;
	const strumDuration = (isMute || isBass) ? 0.025 : 0.045;
	const stringDecay = isMute ? 0.15 : 3.0;
	const baseGain = isMute ? 2.8 : (isBass ? 0.9 : 0.6);
	const strIndex = isBass ? [0] : [0, 1, 2, 3, 4, 5];
	const sequence = isDown ? strIndex : [...strIndex].reverse();
	const now = ctx.currentTime;

	sequence.forEach((stringIdx, index) => {
		const delay = (index / 5) * strumDuration;
		const startTime = now + delay;

		const source = ctx.createBufferSource();
		source.buffer = _guitarBuffers[stringIdx];

		const filter = ctx.createBiquadFilter();
		if (isMute) {
			filter.type = 'lowpass';
			filter.frequency.setValueAtTime(1400, startTime);
			filter.Q.setValueAtTime(10, startTime);
		} else {
			filter.type = 'allpass';
		}

		const gainNode = ctx.createGain();
		gainNode.gain.setValueAtTime(0, startTime);
		gainNode.gain.linearRampToValueAtTime(baseGain * (0.9 + Math.random() * 0.2), startTime + 0.005);
		gainNode.gain.exponentialRampToValueAtTime(0.001, startTime + stringDecay);

		source.connect(filter);
		filter.connect(gainNode);
		gainNode.connect(ctx.destination);
		source.start(startTime);
		source.stop(startTime + stringDecay + 0.1);
	});
}
